import { render, staticRenderFns } from "./KeywordsIdeas.vue?vue&type=template&id=033a133f&scoped=true&"
import script from "./KeywordsIdeas.vue?vue&type=script&lang=js&"
export * from "./KeywordsIdeas.vue?vue&type=script&lang=js&"
import style0 from "./KeywordsIdeas.vue?vue&type=style&index=0&id=033a133f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033a133f",
  null
  
)

export default component.exports